<template>
    <v-expansion-panels
        class="rtls-expansion-panels"
        :class="cssClass"
        :readonly="isAlwaysExpanded"
        :model-value="isOpenState"
        multiple
        @change="change"
    >
        <v-expansion-panel class="rtls-expansion-panel">
            <v-expansion-panel-title v-if="label" class="rtls-expansion-panel-header" hide-actions>
                <template v-slot:default="{ expanded }">
                    <p class="rtls-expansion-panel-header__label">
                        {{ toSentenceCase($t(label)) }}
                    </p>
                    <span v-if="isStoreGroups" class="asterisk">*</span>

                    <main-expand-button :is-expanded="expanded" size="small" />
                </template>
            </v-expansion-panel-title>
            <v-expansion-panel-text
                class="rtls-expansion-panel-content"
                :class="expansionPanelClass"
            >
                <slot />
            </v-expansion-panel-text>
        </v-expansion-panel>
    </v-expansion-panels>
</template>

<script setup>
import { computed } from 'vue';
import { includes } from 'lodash';

defineOptions({ inheritAttrs: false });

const props = defineProps({
    label: String,
    cssClass: String,
    expansionPanelClass: String,
    isOpenState: {
        type: Number,
        default: 0, // 0 - open
    },
    children: {
        type: Array,
        default: () => [],
    },
    change: {
        type: Function,
        default: () => {},
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    editable: {
        type: Boolean,
        default: true,
    },
});

// never mutated: mirrors the original data() value, which was also never reassigned
const isAlwaysExpanded = false;

const isStoreGroups = computed(() => includes(props.label, 'storeGroups'));
</script>

<style lang="scss" scoped>
.rtls-expansion-panel {
    .rtls-expansion-panel-header {
        padding: 0;
        justify-content: start;

        > * {
            flex-grow: 0;
        }

        :deep(.v-icon) {
            margin-left: 0.5rem;
        }

        .asterisk {
            font-weight: 400;
            font-size: 1.8rem;
            line-height: 2rem;
            padding-left: 0.3rem;
        }

        &__label {
            font-size: 1.2rem;
            line-height: 1.6rem;
            font-weight: 600;
        }
    }
}
</style>
